'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSupplementalInitialMessages = fetchSupplementalInitialMessages;

var _noAuthApiClient = require('../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSupplementalInitialMessages(_ref) {
  var botId = _ref.botId,
      sessionId = _ref.sessionId;

  return _noAuthApiClient2.default.getWithResponse('livechat/v1/bots/public/bot/' + botId + '/welcomeMessages', {
    query: { sessionId: sessionId }
  });
}